var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 3.94625L14.7813 5.13563C16.223 5.96801 17.3498 7.25286 17.9868 8.7909C18.6239 10.3289 18.7357 12.0342 18.3048 13.6423C17.8739 15.2503 16.9245 16.6712 15.6038 17.6847C14.283 18.6981 12.6648 19.2474 11 19.2474C9.33524 19.2474 7.71699 18.6981 6.39624 17.6847C5.0755 16.6712 4.12606 15.2503 3.69519 13.6423C3.26432 12.0342 3.37609 10.3289 4.01316 8.7909C4.65024 7.25286 5.77702 5.96801 7.21875 5.13563L6.53125 3.94625C4.82739 4.92998 3.49574 6.44844 2.74283 8.26612C1.98992 10.0838 1.85783 12.0991 2.36704 13.9995C2.87625 15.9 3.99832 17.5792 5.5592 18.777C7.12008 19.9747 9.03255 20.6239 11 20.6239C12.9675 20.6239 14.8799 19.9747 16.4408 18.777C18.0017 17.5792 19.1237 15.9 19.633 13.9995C20.1422 12.0991 20.0101 10.0838 19.2572 8.26612C18.5043 6.44844 17.1726 4.92998 15.4688 3.94625Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 1.375H11.6875V11H10.3125V1.375Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.5ecd33c142c69c0bc8ea584c7c534ec7.svg";
export { ForwardRef as ReactComponent };